import React from 'react'
import { MenuItem as MuiMenuItem } from '@material-ui/core'
import { MenuItemProps } from '@material-ui/core/MenuItem'
import styleOverride from './style'

const MenuItem: React.FC<MenuItemProps> = React.forwardRef((props, ref) => {
  return <MuiMenuItem {...props} classes={styleOverride()} />
})

MenuItem.displayName = 'MenuItem'

export default MenuItem
